import _ from 'lodash';
import { parse } from 'query-string';
import { STATES } from '../constants/general';
import { ACCOUNT_TYPE_OPTIONS, DEPOSIT_OPTIONS } from '../constants/payment';

const ACCOUNT_NUMBER_BANK = [
  28033062, 89733529, 65130762, 16260679, 66970730, 88519093, 88985532, 95471647, 34873310,
  43476537, 57571556,
];
const ROUTING_NUMBER_BANK = [
  252984520, 223947429, 519976804, 857168141, 373482575, 399123218, 210940551, 507612563, 309620007,
  536097649, 262928167,
];
const DEALER_ID_BANK = [1820, 7739, 1113, 5018];
const BANK_NAME_BANK = ['Bank of America', 'Chase', 'Wells Fargo', 'Capital One', 'Citibank'];
const NAME_BANK = [
  'Syreeta Spraggins',
  'Alden Tomlin',
  'Leora Matheney',
  'Keenan Paolucci',
  'Ivette Pigeon',
  'Thanh Cyphers',
  'Elisa Bowens',
  'Daniela Beers',
  'Adelia Hazen',
  'Flor Archer',
];
const FIRST_NAME_BANK = _.map(NAME_BANK, (name) => _.split(name, ' ')[0]);
const LAST_NAME_BANK = _.map(NAME_BANK, (name) => _.split(name, ' ')[1]);
const EMAIL_BANK = [
  'Nunc.sed@Proinvel.edu',
  'nec.urna@facilisisloremtristique.edu',
  'sem.ut.cursus@eunulla.ca',
  'mi@quamquisdiam.co.uk',
  'ac.orci.Ut@Nunclectuspede.ca',
  'Proin@dui.edu',
  'iaculis.aliquet@Crasvulputatevelit.com',
  'facilisis.magna.tellus@liberonec.net',
  'Integer@magnaLorem.ca',
  'risus@tincidunt.org',
  'erat@Donecnibh.co.uk',
  'luctus.Curabitur@consectetueripsum.com',
  'adipiscing.fringilla.porttitor@quis.org',
  'senectus.et.netus@Nulla.co.uk',
  'cubilia.Curae.Donec@molestie.net',
  'euismod.enim.Etiam@semmollisdui.co.uk',
  'dignissim.lacus.Aliquam@magnaLorem.com',
  'augue.scelerisque.mollis@Nuncullamcorpervelit.co.uk',
  'ultricies.ornare.elit@elit.org',
  'nisl.sem@inceptoshymenaeosMauris.edu',
  'a.auctor.non@dolor.com',
  'euismod@Suspendissenonleo.net',
  'vitae@temporerat.co.uk',
  'Mauris.vestibulum.neque@ornarefacilisis.com',
  'turpis.vitae.purus@Etiambibendum.ca',
  'et@Nuncsollicitudin.co.uk',
  'massa@pulvinararcu.edu',
  'feugiat.tellus@semperpretium.org',
  'aliquet.metus.urna@ultriciesdignissim.org',
  'cursus.purus@risus.ca',
];
const ADDRESS_BANK = [
  '526-3499 Ullamcorper, Rd.',
  '4387 Sed Avenue',
  'P.O. Box 467, 471 Eu Avenue',
];
const ADDRESS2_BANK = ['suite 3', 'apt 2', 'lot 6', '2nd floor', 'unit 16'];
const CITY_BANK = ['Austin', 'Springfield', 'Hawthorne', 'Paris', 'Heidelberg', 'Southend', 'Erie'];
const ZIP_BANK = ['11101', '60202', '38270', '64889'];
const SENTENCE_BANK = [
  'Cherubfish, salamanderfish, dartfish dealfish gombessa slimy mackerel bangus, ocean perch.',
  'Driftfish greeneye mackerel shark dartfish Razorback sucker roughy snook lampfish.',
  'African glass catfish silverside.',
  'Burrowing goby blue eye Chinook salmon gianttail Colorado squawfish; blenny; whale catfish hawkfish.',
  'Riffle dace tailor tadpole cod knifefish Red salmon, medaka, yellow weaver ling cod.',
  'Trumpetfish channel catfish bandfish trevally roach yellowfin skilfish, ribbonbearer.',
];
const WORD_BANK = [
  'diam',
  'erat',
  'nunc',
  'lectus',
  'condimentum.',
  'Nullam',
  'at',
  'eget',
  'velit',
  'Nam',
  'aliquet',
  'augue.',
  'dolor.',
  'enim',
  'nisi.',
  'sem',
  'nulla.',
  'auctor',
  'urna.',
  'eget',
  'eros',
  'magna',
  'tincidunt',
  'Aliquam',
  'accumsan',
  'facilisis',
  'mauris',
  'nisl.',
  'ornare',
  'enim.',
  'aliquet',
  'nibh',
  'Curabitur',
  'sollicitudin',
  'vel',
  'dui',
  'justo',
  'non',
  'Donec',
  'lorem',
  'ultrices.',
  'luctus',
  'ipsum',
  'Aenean',
  'pede,',
  'Donec',
  'viverra.',
  'mauris.',
  'quis',
  'vitae',
  'arcu.',
  'lobortis',
  'magna,',
  'vitae',
  'Suspendisse',
  'Mauris',
  'vehicula.',
  'sollicitudin',
  'et,',
  'dolor.',
  'In',
  'ligula',
  'urna.',
  'sed',
  'convallis',
  'faucibus.',
  'urna.',
  'interdum',
  'Class',
  'Vivamus',
  'non',
  'nisl',
  'Aliquam',
  'Fusce',
  'nec',
  'penatibus',
  'nisi.',
  'Curabitur',
  'et',
  'Nullam',
  'Quisque',
  'In',
  'inceptos',
  'sociosqu',
  'Quisque',
  'augue',
  'lacinia',
  'Suspendisse',
  'sem',
  'torquent',
  'felis',
  'mauris',
  'euismod',
  'ridiculus',
  'purus',
  'ornare',
  'vitae',
  'eu',
  'ut',
  'risus.',
];
const DEALERSHIP_NAME_BANK = [
  'Ford valley Ford',
  '6 Towns Chrystler',
  '3 Towns Toyota',
  'Peter Pan BMW',
  'Harrison County Ford',
  'Sals Used Auto',
  'Jack Frost Honda',
  'Kia of Tokyo',
];

export function testDataIfRequested(...fields) {
  if (typeof window !== 'undefined' && _.get(parse(window.location.search), 'testData')) {
    return _.chain(fields)
      .filter(_.isObject)
      .reduce((acc, field) => {
        acc[_.get(field, 'name')] = !_.isFunction(field.custom)
          ? (() => {
              const type = _.get(field, 'type');
              switch (type) {
                case 'processorName':
                  return `${_.sample(FIRST_NAME_BANK)} ${_.sample(LAST_NAME_BANK)}`;
                case 'dealershipName':
                  return _.sample(DEALERSHIP_NAME_BANK);
                case 'dealershipAddress':
                  return _.sample(ADDRESS_BANK);
                case 'dealershipAddress2':
                  return _.sample(ADDRESS2_BANK);
                case 'dealerEmail':
                  return _.sample(EMAIL_BANK);
                case 'bankName':
                  return _.sample(BANK_NAME_BANK);
                case 'dealerCity':
                  return _.sample(CITY_BANK);
                case 'dealerState':
                  return _.sample(STATES);
                case 'dealerZip':
                  return _.sample(ZIP_BANK);
                case 'dealerId':
                  return _.sample(DEALER_ID_BANK);
                case 'name':
                  return `${_.sample(FIRST_NAME_BANK)} ${_.sample(LAST_NAME_BANK)}`;
                case 'companyName':
                  return _.sample(DEALERSHIP_NAME_BANK);
                case 'firstName':
                  return _.sample(FIRST_NAME_BANK);
                case 'lastName':
                  return _.sample(LAST_NAME_BANK);
                case 'email':
                  return _.sample(EMAIL_BANK);
                case 'address':
                  return _.sample(ADDRESS_BANK);
                case 'city':
                  return _.sample(CITY_BANK);
                case 'state':
                  return _.sample(STATES);
                case 'zipCode':
                  return _.sample(ZIP_BANK);
                case 'sentence':
                  return _.sample(SENTENCE_BANK);
                case 'routingNumber':
                  return _.sample(ROUTING_NUMBER_BANK);
                case 'accountNumber':
                  return _.sample(ACCOUNT_NUMBER_BANK);
                case 'accountType':
                  return _.sample(ACCOUNT_TYPE_OPTIONS);
                case 'depositType':
                  return _.sample(DEPOSIT_OPTIONS);
                case 'number':
                  return _.sample(_.range(1, 20)) + _.sample(_.range(0, 100)) / 100;
                default:
                  return _.sample(WORD_BANK);
              }
            })()
          : field.custom(field);
        return acc;
      }, {})
      .value();
  } else {
    return undefined;
  }
}

export const newAccountFormTestDataIfRequested = _.partial(
  testDataIfRequested,
  {
    name: 'dealerId',
    type: 'dealerId',
  },
  {
    name: 'companyName',
    type: 'companyName',
  },
  {
    name: 'address',
    type: 'address',
  },
  {
    name: 'city',
    type: 'city',
  },
  {
    name: 'state',
    type: 'state',
  },
  {
    name: 'zipCode',
    type: 'zipCode',
  },
  {
    name: 'routingNumber',
    type: 'routingNumber',
  },
  {
    name: 'bankName',
    type: 'bankName',
  },
  {
    name: 'accountNumber',
    type: 'accountNumber',
  },
  {
    name: 'accountType',
    type: 'accountType',
  },
  {
    name: 'submittedByName',
    type: 'name',
  },
  {
    name: 'submittedByEmail',
    type: 'email',
  },
  {
    name: 'amount',
    type: 'number',
  },
  {
    name: 'checkNumber',
    type: 'dealerId',
  },
  {
    name: 'accountType',
    type: 'accountType',
  },
  {
    name: 'depositType',
    type: 'depositType',
  },
  {
    name: 'memo',
    type: 'sentence',
  },
);

export const dealerOnboardTestDataIfRequested = _.partial(
  testDataIfRequested,
  {
    name: 'processorName',
    type: 'processorName',
  },
  {
    name: 'dealershipName',
    type: 'dealershipName',
  },
  {
    name: 'dealershipAddress',
    type: 'dealershipAddress',
  },
  {
    name: 'dealershipAddress2',
    type: 'dealershipAddress2',
  },
  {
    name: 'dealerCity',
    type: 'dealerCity',
  },
  {
    name: 'dealerState',
    type: 'dealerState',
  },
  {
    name: 'dealerZip',
    type: 'dealerZip',
  },
  {
    name: 'dealerEmail',
    type: 'dealerEmail',
  },
);
